/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CirclePlusFilled = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="#2F3037" />
      <path d="M6.5 12H17.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 6.5V17.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#2F3037" />
    </BaseSvgIcon>
  )
}

export default CirclePlusFilled
